<template>
  <div class="relative">
    <div
      class="flex flex-col justify-between space-y-4 py-4 transition sm:flex-row sm:items-center sm:space-y-0"
    >
      <div class="flex items-center">
        <div class="pl-4 sm:px-6">
          <img
            :src="data.extension_logo"
            :alt="data.extension_name"
            class="h-12 w-12 rounded-lg"
          />
        </div>
        <div class="flex flex-col space-y-2 pl-4 sm:space-y-0 sm:pl-0">
          <div class="flex items-center space-x-2">
            <div
              class="flex items-center rounded-sm text-xs text-ontick-steel-500 dark:text-ontick-graphite-200"
              v-if="data.extension_price"
            >
              <span
                class="text-sm font-bold text-ontick-carbon-900 dark:text-gray-300"
                >{{ data.extension_price | currency }}</span
              ><span>/mês</span>
            </div>
            <ontick-plan-logo-component
              :plan="
                data.required_plan === 'SUBSCRIPTION' &&
                data.extension_price === 0
                  ? 'FREE'
                  : data.required_plan
              "
              v-else
            />
            <span class="text-sm font-bold leading-none sm:text-base">
              {{ data.extension_name }}
            </span>
          </div>
          <p class="text-xs text-gray-400 sm:text-sm">
            {{ data.extension_short_desc }}
          </p>
        </div>
      </div>
      <div class="flex items-center justify-end space-x-4 pl-4">
        <div class="flex items-center justify-end">
          <ontick-button
            :disabled="data.active_for_user"
            customClass="text-gray-300 bg-ontick-blue-700 dark:bg-ontick-blue-900 disabled:bg-transparent dark:disabled:bg-transparent disabled:border disabled:border-ontick-green-900 disabled:text-ontick-green-900 dark:disabled:text-ontick-green-600"
            @click.native="
              openDetails({
                extension_id: data.extension_id,
                partner_name: data.extension_owner,
              })
            "
            class="space-x-2 text-sm"
            :class="data.active_for_user ? 'mr-0 cursor-not-allowed' : 'mr-4'"
            size="small"
          >
            <i v-html="$icons.material_check" v-if="data.active_for_user"></i>
            <span v-if="data.active_for_user"> Ativo </span>
            <span v-else> Ver detalhes </span>
          </ontick-button>

          <button
            class="relative py-1 px-4 text-ontick-graphite-400 transition hover:text-ontick-graphite-500"
            @click.stop="toggleDropdown"
            content="Ver detalhes"
            v-tippy="{ arrow: true, theme: 'green' }"
            v-if="data.active_for_user"
          >
            <i v-html="$icons.kebab" class="h-4 w-4"></i>
            <span class="sr-only"> Ver detalhes </span>
          </button>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="ease-in-out duration-200"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in-out duration-200"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <details-dropdown-component
        v-if="dropdownIsActive"
        @close="closeDropdown"
        class="right-0 top-14 z-50"
        :detailsId="data.extension_id"
        :owner="data.extension_owner"
        :isActive="data.active_for_user"
        @subscription="$emit('subscription')"
        :price="data.extension_price"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OntickPlanLogoComponent from "../../../../shared/components/basic/ontick-plan-logo.component.vue";
import detailsDropdownComponent from "./details-dropdown.component.vue";
import PlanBadgeComponent from "./plan-badge.component.vue";
export default {
  components: {
    detailsDropdownComponent,
    PlanBadgeComponent,
    OntickPlanLogoComponent,
  },

  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      dropdownIsActive: false,
    };
  },

  methods: {
    ...mapActions({
      setDetailsIsActive: "extensions/setDetailsIsActive",
      setDetailsId: "extensions/setDetailsId",
    }),
    toggleDropdown() {
      this.dropdownIsActive = !this.dropdownIsActive;
    },
    closeDropdown() {
      this.dropdownIsActive = false;
    },
    openDetails({ extension_id, partner_name }) {
      this.$router.push({
        name: "Detalhes da extensão",
        params: {
          extension_id,
          partner_name: partner_name.replaceAll(" ", "").toLowerCase(),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
